import ParameterErrors from '../../../errors/ParameterErrors';
import QuadrantReason from '../QuadrantReason';
const { throwNotProvided } = ParameterErrors;
const OBJECT_IDS_JSON_KEY='o';
const REASONS_JSON_KEY='r';
const CUBE_JSON_KEY='c';
export default class Quadrant {
	constructor({objectIds, reasons, cube}){
		this._objectIds = objectIds;
		this._reasons = reasons;
		this._cube = cube;
		this.getObjectIds = this.getObjectIds.bind(this);
		this.getReasons = this.getReasons.bind(this);
	}
	getObjectIds(reasonsOut){
		return this._objectIds;
	}
	getReasons(){
		return this._reasons;
	}
	static fromJSON(jObject){
		const objectIds = jObject[OBJECT_IDS_JSON_KEY];
		const jArrayReasons = jObject[REASONS_JSON_KEY];
		const cube = jObject[CUBE_JSON_KEY];
		const reasons = jArrayReasons?jArrayReasons.map(jObjectReason=>QuadrantReason.fromJSON(jObjectReason)):null;
		return new Quadrant({objectIds, reasons, cube});
	}
}